import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import { colors } from "../../utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function IyugaDropdown({ options, selected, onSelect, label }) {
  const [isOpen, setIsOpen] = useState(false);

  

  return (
    <Dropdown onToggle={(isOpen) => setIsOpen(isOpen)}>
      <Dropdown.Toggle
        variant="outline-light"
        id="dropdown-basic"
        bsPrefix="custom-dropdown" // ✅ Removes Bootstrap's default arrow
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "10px 15px",
          background: "white",
          fontSize: "14px",
          fontFamily: "DM Sans, sans-serif",
          fontWeight: "500",
          color: colors.darkGrey,
          cursor: "pointer",
          width: "150px",
        }}
      >
        {selected}
        <span style={{ marginLeft: "8px", transition: "transform 0.2s ease" }}>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}{" "}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "8px",
          background: "white",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          width: "200px",
        }}
      >
        {options.map(({ value, label }) => (
          <Dropdown.Item
            key={value}
            onClick={() => onSelect(value)}
            style={{
              margin: "8px 0px",
              fontSize: "14px",
              fontFamily: "DM Sans, sans-serif",
              borderRadius: "8px",
              color: colors.textBlue,
              background: selected === value ? "#EDE9FE" : "transparent",
              fontWeight: selected === value ? "600" : "400",
              cursor: "pointer",
            }}
          >
            {label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

// ✅ Define PropTypes
IyugaDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired, // Button text
};

// ✅ Default Props
IyugaDropdown.defaultProps = {
  selected: "",
};
